package com.essntl.features.crm.ui.contactorganization

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactScreen
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.customfields.ui.CustomFieldsEvent
import com.essntl.features.customfields.ui.CustomFieldsScreen
import com.essntl.features.customfields.ui.CustomFieldsState
import com.essntl.features.organization.ui.OrganizationEvent
import com.essntl.features.organization.ui.OrganizationScreen
import com.essntl.features.organization.ui.OrganizationState
import com.essntl.features.organization.ui.OrganizationValidation
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.mohamedrejeb.calf.core.LocalPlatformContext

@Composable
fun ContactOrganizationScreen(
    state: ContactOrganizationState,
    onEvent: (ContactOrganizationEvent) -> Unit,
    organizationState: OrganizationState,
    onOrganizationEvent: (OrganizationEvent) -> Unit,
    organizationValidation: OrganizationValidation,
    organizationAddressState: AddressState,
    onOrganizationAddressEvent: (AddressEvent) -> Unit,
    organizationAddressValidation: AddressValidation,
    contactState: ContactState,
    onContactEvent: (ContactEvent) -> Unit,
    contactValidation: ContactValidation,
    contactAddressState: AddressState,
    onContactAddressEvent: (AddressEvent) -> Unit,
    contactAddressValidation: AddressValidation,
    customFieldsState: CustomFieldsState,
    onCustomFieldsEvent: (CustomFieldsEvent) -> Unit,
) {
    val context = LocalPlatformContext.current

    LaunchedEffect(Unit) {
        organizationValidation.organizationForm.reset()
        organizationValidation.organizationForm.name.value = ""

        organizationAddressValidation.addressForm.reset()
        organizationAddressValidation.addressForm.line1.value = ""
        organizationAddressValidation.addressForm.city.value = ""
        organizationAddressValidation.addressForm.country.value = ""

        contactAddressValidation.addressForm.reset()
        contactAddressValidation.addressForm.line1.value = ""
        contactAddressValidation.addressForm.city.value = ""
        contactAddressValidation.addressForm.country.value = ""
    }

    LaunchedEffect(organizationState.uploadLogo.isSuccess) {
        if (organizationState.uploadLogo.isSuccess) {
            onEvent(
                ContactOrganizationEvent.Submit(
                    organization = organizationState.organization.value,
                    organizationAddress = if (organizationState.addAddress)
                        organizationAddressState.address.value else
                        null,
                    contact = contactState.contact.value,
                    contactAddress = if (contactState.addAddress)
                        contactAddressState.address.value else
                        null,
                    customFields = customFieldsState.customFields.value,
                ),
            )
            onOrganizationEvent(OrganizationEvent.ClearLogo)
        }
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxSize(),
    ) {
        Box(
            modifier =
                Modifier
                    .weight(1f),
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(1.spacing),
                modifier =
                    Modifier
                        .fillMaxHeight()
                        .padding(end = 1.5f.spacing)
                        .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
                        .verticalScroll(rememberScrollState()),
            ) {
                OrganizationScreen(
                    state = organizationState,
                    onEvent = onOrganizationEvent,
                    validation = organizationValidation,
                    addressState = organizationAddressState,
                    onAddressEvent = onOrganizationAddressEvent,
                    addressValidation = organizationAddressValidation,
                )

                ContactScreen(
                    state = contactState,
                    onEvent = onContactEvent,
                    validation = contactValidation,
                    addressState = contactAddressState,
                    onAddressEvent = onContactAddressEvent,
                    addressValidation = contactAddressValidation,
                )

                CustomFieldsScreen(
                    state = customFieldsState,
                    onEvent = onCustomFieldsEvent,
                )
            }
        }

        Spacer(modifier = Modifier.height(1.dp))

        Box(
            modifier = Modifier
                .background(MaterialTheme.esColorScheme.bgSecondary)
                .padding(2.5.spacing),
        ) {
            EsLargePrimaryButton(
                onClick = {
                    val validateOrganization = organizationValidation.organizationForm.validate()

                    val validateOrganizationAddress =
                        (if (organizationState.addAddress) organizationAddressValidation.addressForm.validate() else true)

                    val validateContact = contactValidation.contactForm.validate()

                    val validateContactAddress =
                        (if (contactState.addAddress) contactAddressValidation.addressForm.validate() else true)


                    if (validateOrganization &&
                        validateOrganizationAddress &&
                        validateContact &&
                        validateContactAddress
                    ) {
                        if (organizationState.organization.value.id.isNotEmpty())
                            onEvent(
                                ContactOrganizationEvent.Submit(
                                    organization = organizationState.organization.value,
                                    organizationAddress = if (organizationState.addAddress)
                                        organizationAddressState.address.value else
                                        null,
                                    contact = contactState.contact.value,
                                    contactAddress = if (contactState.addAddress)
                                        contactAddressState.address.value else
                                        null,
                                    customFields = customFieldsState.customFields.value,
                                ),
                            )
                        else
                            onOrganizationEvent(OrganizationEvent.InsertLogo(context))
                    }
                },
                text = "Save",
                loading = organizationState.uploadLogo.isLoading ||
                    state.addContactOrganization.isLoading,
                modifier = Modifier.fillMaxWidth(),
            )
        }
    }
}